import Vue from 'vue';

// Verificamos si esta logueado
const loggedIn =  JSON.parse(localStorage.getItem('user'));
let permissions = [];
if(loggedIn){
	permissions = loggedIn.profile ? loggedIn.profile.permissions.map(x => x['permission']) : [];
	if(loggedIn.employee)
		permissions.push('employee');
}

// Vue.directive('can', {
// 	bind: function (el, binding, vnode) {
// 		if (!permissions
// 			.includes(binding.expression
// 				.replace(/'/g, "")
// 				.replace(/"/g, ""))) {
// 			vnode.elm.style.display = "none";
// 		}
// 	}
// });

Vue.directive('can', {
	bind: function (el, binding) {
		const userPermissions = permissions;
		let requiredPermissions = binding.value;

		if (typeof requiredPermissions === 'string') {
		requiredPermissions = [requiredPermissions];
		}

		const hasPermission = requiredPermissions.some(p =>
		userPermissions.includes(p)
		);

		if (!hasPermission) {
		el.style.display = 'none';
		}
	}
});

Vue.directive('canand', {
	bind: function (el, binding) {
		const userPermissions = permissions;
		let requiredPermissions = binding.value;

		if (typeof requiredPermissions === 'string') {
		requiredPermissions = [requiredPermissions];
		}

		const hasPermission = requiredPermissions.every(p =>
		userPermissions.includes(p)
		);

		if (!hasPermission) {
		el.style.display = 'none';
		}
	}
});

Vue.directive('cant', {
	bind: function (el, binding) {
		const userPermissions = permissions;
		let requiredPermissions = binding.value;

		if (typeof requiredPermissions === 'string') {
		requiredPermissions = [requiredPermissions];
		}

		const hasPermission = requiredPermissions.some(p =>
		userPermissions.includes(p)
		);

		if (hasPermission) {
			el.style.display = 'none';
		}
	}
});